import { z } from "zod"

export const directionSchema = z.enum(["asc", "desc"])

export type Direction = z.infer<typeof directionSchema>

export type Sorted<C extends string> = { sort: C; direction: Direction }

export function nextSort<C extends string>(
  current: Sorted<C>,
  column: C,
  fallback: C,
): { sort: C | undefined; direction: Direction | undefined } {
  const direction =
    column === current.sort && current.direction === "asc" ? "desc" : "asc"
  return column === fallback && direction === "asc"
    ? { sort: undefined, direction: undefined }
    : { sort: column, direction }
}

export function columnsParam<C extends string>(
  columns: C[],
  defaults: readonly C[],
): C[] | undefined {
  const unchanged =
    columns.length === defaults.length &&
    columns.every((column) => defaults.includes(column))
  return unchanged ? undefined : columns
}

export function withFixed<C extends string>(
  all: readonly C[],
  fixed: C,
  columns: C[],
): C[] {
  return all.filter((column) => column === fixed || columns.includes(column))
}
